module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wind-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "onerror": _vm.imgErrorHandler
    },
    on: {
      "click": _vm.onClick
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f3fa52d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/img/Img.vue
// module id = 588
// module chunks = 1